import React from 'react';
import styled from 'styled-components';
import CustomTitle from '../title/CustomTitle';
import { isMobileOnly } from "react-device-detect";

const PrivacPopupBlock = styled.div`
    position:relative;
    width: 100%;
    height: 100%;
    //top: 50%;
    //left: 50%;
    //right: auto;
    //bottom: auto;
    //border-radius: 10px;
    //overflow: hidden;
    //display: flex;
`;

const PrivacyPopupContentsBlock = styled.div`
/*    width: 97%;
    height: 97%;
    background-color:#fff;
    border-radius: 10px;
    padding: 30px;
    overflow: auto;*/
    position:absolute;
    top:0;
    left:0;
    ${isMobileOnly?`
    width: 92vw;
    height:80vw;   
    `:`
    width: 530px;
    height:532px;
    `};
    background-color:#fff;
    border-radius: 10px;
    padding: 103px 30px 30px;
    overflow: auto;
`;

const PrivacyPopupCloseIconBlock = styled.img`
    display: block;
    position: absolute;
    z-index:2;
    top: -10px;
    right: -10px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    src:${(props) => (props.src)};
`;

const PrivacyPopupSpanBlock = styled.span`
    font-size: 14px;
    width: 100%;
`;

const PrivacyPopupTableBlock = styled.table`

    border-top: 2px solid #111;
    border-bottom: 1px solid #ccc;
    width: 95%;
    
    th {
        padding: 13px 5px 14px;
        font-size: 14px;
        text-align: center;
    }

    td {
        line-height: 1.5;
        position: relative;
        padding: 20px;
        border-top: 1px solid #ccc;
        vertical-align: middle;
        font-size: 14px;
      }

      td.border_bottom {
        border-bottom: 1px solid #ccc;
      }

      td.border_right {
        border-right: 1px solid #ccc;
      }

      td.border_black {
        border-bottom: 1px solid #111;
      }

      td.border_none {
        border-top: none;
      }

      td.border_t-none {
        border-top: none;
      }

      td.padding_none {
        padding: 6px 0;
      }

      td.thumb_none {
        padding-left: 120px;
      }

      b {
        font-weight: 700;
      }

      .mint {
        background-color: rgba(0, 217, 184, 0.1);
      }

      .gray {
        background-color: #f4f4f4;
      }

      .input-box .text-input:disabled {
        color: #999;
        background-color: #e7e7e7;
      }
`;

const FixedTitleBlock = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    padding: 30px 0;
    z-index: 1;
    background-color: white;
    ${isMobileOnly?`
    width: 92vw; 
    `:`
    width: 530px;
    `};
    border-radius: 10px;
`;

const FixedBottomBlock = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    z-index: 1;
    background-color: white;
    ${isMobileOnly?`
    width: 92vw;
    height:30px;   
    `:`
    width: 530px;
    height:30px;
    `};
    border-radius: 10px;
`;
const PrivacyPopup = ({ onClickIcon }) => {
    return (
        <PrivacPopupBlock>
          <PrivacyPopupCloseIconBlock
            onClick={onClickIcon}
            src="/assets/images/icon/close_icon.png" />

            <FixedTitleBlock>
                <CustomTitle title="개인정보처리방침" textColor="#111" marginBottom="0" marginTop="10px" />
            </FixedTitleBlock>
            <FixedBottomBlock />
            <PrivacyPopupContentsBlock>
                <PrivacyPopupSpanBlock>
                  <CustomTitle title="개인정보의 수집항목 및 이용 목적"
                               textColor="#111" fontSize="16px" marginBottom="26px" textAlign="left" />
어디가구는 다음과 같이 개인정보를 수집·이용하고 있습니다. <br />
개인정보가 필요한 시점에 최소한의 정보만을 수집하며, 고지한 범위 내에서만 사용합니다. <br />
또한 사전 동의 없이 고지한 범위를 초과하여 이용하거나 외부에 공개하지 않습니다.<br />
어디가구는 회원가입 시 서비스 제공과 편리하고 유익한 맞춤 정보를 제공하기 위해 필요한 최소한의 정보를 필수 사항으로 수집하고 있습니다. <br />
어디가구는 회원님의 소중한 인권을 침해할 우려가 있는 민감한 정보(인종, 사상 및 신조, 정치적 성향 이나 범죄기록, 의료정보 등)는 어떠한 경우에도 수집하지 않으며, 만약 불가피하게 수집하는 경우에는 반드시 회원님에게 사전 동의를 구하겠습니다.<br />
                    <br></br>
필수사항
<br />
                </PrivacyPopupSpanBlock>
                <br />
                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="30%" />
                        <col width="35%" />
                        <col width="35%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>수집.이용목적</td>
                            <td>수집.이용항목</td>
                            <td>보유 및 이용기간</td>
                        </tr>
                        <tr>
                            <td>회원가입 </td>
                            <td>성명, 휴대폰 번호, ID(이메일 주소), 비밀번호, 닉네임 </td>
                            <td rowSpan='2'> • 회원 탈퇴 시 즉시 삭제(단, 재가입 검증 및 부정이용 배제를 위해 이름, 휴대폰 번호, CI/DI의 경우 6개월 동안 보관) </td>
                        </tr>
                        <tr>
                            <td>본인확인, 성인인증  </td>
                            <td> • 본인확인기관에서 제공하는 본인인증결과값(CI/DI), 생년월일, 성별 <br />
• SNS계정(애플, 페이스북, 카카오톡, 네이버)의 이메일 주소, 생년월일, 휴대폰 번호 </td>

                        </tr>
                        <tr>
                            <td>주문 결제 및 배송  </td>
                            <td rowSpan='2'>수취인 성명, 수취인의 휴대폰 번호, 배송지 주소, 결제 정보(결제 승인내역, 계좌정보, 휴대폰 번호)  </td>
                            <td > • 전자상거래법에 따라 거래기록 보존을 위한 정보(ID, 계좌번호, 배송지 주소, 결제·취소·환불 정보)는 5년간 보관  </td>
                        </tr>
                        <tr>
                            <td>고객 상담 및 불만처리  </td>
                            <td > • 소비자의 불만 또는 분쟁처리에 관한 기록은 3년간 보관 </td>
                        </tr>
                        <tr>
                            <td>서비스 개선을 위한 통계 분석 </td>
                            <td>쿠키, 서비스 이용기록(최근접속일, 접속 IP 정보, 구매로그, 이벤트로그)</td>
                            <td>• 통신비밀보호법에 따라 IP는 3개월 보관 </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>
                <br />
                <PrivacyPopupSpanBlock>
                    ※ 대금결제시 수집하는 개인정보는 결제대행업체(PG사)에서 수집 및 저장하고 있으며, 회사는 결제대행업체에서 제공하는 거래내역만을 제공받고 있습니다.
<br />
※ CI : 본인확인기관에서 부여하는 개인식별정보
<br />
※ DI : 실명인증서비스 업체마다 부여하는 사용자 고유번호
<br /><br /><br />
1.1 서비스 개선을 위한 통계 분석
<br /><br />
서비스 이용 과정 또는 처리 과정에서 다음과 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
<br /><br />
- 서비스 이용 기록, 접속로그, 쿠키
<br /><br />
선택사항
<br /><br />
                </PrivacyPopupSpanBlock>
                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="30%" />
                        <col width="35%" />
                        <col width="35%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>수집.이용목적</td>
                            <td>수집.이용항목</td>
                            <td>보유 및 이용기간</td>
                        </tr>
                        <tr>
                            <td>마케팅 및 분석   </td>
                            <td rowSpan='2'>휴대폰 번호, 이메일, DM, SMS·LMS의 마케팅 수신 동의 여부 (수집·이용항목은 마케팅 및 분석, 프로모션의 목적에 따라 달라질 수 있으며, 수집 시점에 안내 후 동의여부를 확인함) </td>
                            <td rowSpan='2'> • 정보 삭제 또는 이용 정지 요청을 및 회원탈퇴 시 즉시 삭제 </td>
                        </tr>
                        <tr>
                            <td>프로모션 </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>

                <PrivacyPopupSpanBlock>
                    <br />
                ※ 이벤트 등을 위해 추가적인 개인정보를 수집하여야 할 경우, 회사는 수집 항목에 대해 필수/선택을 구분하여 해당 페이지에서 개인정보의 수집목적, 보유기간 등을 고객에게 고지하고 별도의 추가적 동의를 받습니다.
<br /><br />
제휴문의 및 입점 신청 <br /><br />
                </PrivacyPopupSpanBlock>
                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="30%" />
                        <col width="35%" />
                        <col width="35%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>수집.이용목적</td>
                            <td>수집.이용항목</td>
                            <td>보유 및 이용기간</td>
                        </tr>
                        <tr>
                            <td>문의 및 입점 상담    </td>
                            <td>성함, 휴대폰 번호, 이메일 </td>
                            <td> • 이용 정지 요청 시 즉시 삭제  </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>

                <PrivacyPopupSpanBlock>
                    <br />
                2. 개인정보의 보유 및 이용기간
<br /><br />
어디가구는 원칙적으로 개인정보 이용목적 달성 후에는 해당 개인정보를 지체 없이 파기합니다. 단, 내부방침 및 관계법령의 규정에 의하여 보존할 필요가 있는 경우 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.  <br />
                </PrivacyPopupSpanBlock>
                <br /><br />
                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="40%" />
                        <col width="40%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>구분</td>
                            <td>보존근거</td>
                            <td>보존기간</td>
                        </tr>
                        <tr>
                            <td>계약 또는 청약철회 등에 관한 기록 </td>
                            <td>「전자상거래 등에서의 소비자보호에 관한 법률」 제6조 및 시행령 제6조  </td>
                            <td> 5년  </td>
                        </tr>
                        <tr>
                            <td>대금결제 및 재화 등의 공급에 관한 기록  </td>
                            <td>「전자상거래 등에서의 소비자보호에 관한 법률」 제6조 및 시행령 제6조  </td>
                            <td> 5년  </td>
                        </tr>
                        <tr>
                            <td>소비자의 불만 또는 분쟁처리에 관한 기록  </td>
                            <td>「전자상거래 등에서의 소비자보호에 관한 법률」 제6조 및 시행령 제6조  </td>
                            <td> 5년  </td>
                        </tr>
                        <tr>
                            <td>신용정보의 수집, 처리 및 이용 등에 관한 기록  </td>
                            <td>「신용정보의 이용 및 보호에 관한 법률」   </td>
                            <td> 3년   </td>
                        </tr>
                        <tr>
                            <td>접속에 관한 기록보존  </td>
                            <td>「통신비밀보호법」 제15조의2 및 시행령 제41조   </td>
                            <td> 3개월   </td>
                        </tr>
                        <tr>
                            <td>거래기록 등을 보관해야 하는 경우  </td>
                            <td>「국세기본법」   </td>
                            <td> 10년  </td>
                        </tr>
                        <tr>
                            <td>재가입 검증 및 부정 이용 배제   </td>
                            <td>성명, 휴대폰 번호, 이메일 주소    </td>
                            <td> 6개월   </td>
                        </tr>
                        <tr>
                            <td>부정 이용 방지  </td>
                            <td>회원정보, 구매・배송 등 서비스 이용기록    </td>
                            <td> 3년   </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>

                <PrivacyPopupSpanBlock>
                    <br />
                    3.  개인정보 수집방법
<br /><br />
필수사항 : 회원가입 및 견적 요청서, 상품 주문 시 직접 입력
<br />
- 온라인 및 모바일 홈페이지를 통한 회원가입 및 서비스 이용
<br />
- 로그 분석 수집툴을 통한 생성 정보 수집, ‘쿠키’에 의한 정보 수집
<br /><br />
선택사항 : 특정 상품 주문 시 직접 입력 또는 취소 환불 처리 시점에 유선으로 수집, 서비스 내 특정 기능 이용 시 직접 입력
<br />
- 마케팅, 프로모션 진행 시 이벤트 응모, 기타 전화 등 <br />
                    <br />
4. 개인정보의 파기절차 및 방법
<br /><br />
회원님의 개인정보는 원칙적으로 개인정보의 이용목적이 달성될 경우 지체 없이 파기합니다. 단, 일정기간 동안 어디가구 서비스를 이용하지 아니할 경우 회원님에게 이를 고지하고 별도의 DB에 보관합니다.
<br /><br />
4.1 파기절차
<br />
- 회원님의 개인정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 사유에 따라(보유 및 이용기간 참조) 일정 기간 보관 된 후 파기됩니다.
<br />
- 별도 DB로 옮겨진 개인정보는 법률에 의한 경우를 제외하고는 다른 목적으로 이용되지 않으며 관리자 외 접근을 엄격하게 통제하고 있습니다.
<br /><br />


4.2 파기방법
<br />
- 전자적 파일형태로 저장된 개인정보는 재생할 수 없는 안전한 방법을 사용하여 삭제합니다.
<br />
- 종이에 출력된 개인정보는 분쇄기를 통하여 파기합니다.
<br /><br />
5. 개인정보의 제3자 제공
<br /><br />
어디가구는 원칙적으로 수집 및 이용목적 범위를 넘어 회원님의 개인정보를 제 3자에게 제공하지 않습니다. 다만 원활한 서비스 제공을 위해 상품 구매 시 서비스 제공 업체로 회원님의 개인정보제공(제 3자 제공)이 필요합니다. 이 경우 관련법령에서 요구하는 사항을 회원님에게 안내하고 사전 동의를 구하겠습니다. 또한 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우 회원님의 개인정보를 제공할 수 있습니다. 상품 구매 시 제 3자 제공에 동의한 경우, 해당 서비스 제공 업체에 아래의 개인정보가 제공됩니다.
                </PrivacyPopupSpanBlock>
                <br /><br />
                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="30%" />
                        <col width="70%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>제공 받는 자 </td>
                            <td>상품판매 제휴 업체 </td>
                        </tr>
                        <tr>
                            <td>제공 목적    </td>
                            <td>상품 주문 확인 및 배송 업무  </td>
                        </tr>
                        <tr>
                            <td>제공 정보    </td>
                            <td>• 성명, 휴대폰번호, 이메일 주소, 배송지 주소(구매자와 수취인이 다를 경우 수취인의 정보 제공)  </td>
                        </tr>
                        <tr>
                            <td>보유 및 이용기간    </td>
                            <td>재화 또는 서비스의 제공 목적이 달성된 후 파기(단, 관계법령에 정해진 규정에 따라 법정 기간 동안 보관)  </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>

                <PrivacyPopupSpanBlock>
                    <br /><br />
                    6. 개인정보 취급 위탁
                    <br /><br />
어디가구는 수탁자들이 위탁한 개인정보를 안전하게 처리하고 있는지 지속적으로 관리 감독하고 있으며, 수탁업무가 종료된 때에 수탁자가 보유하고 있는 개인정보는 즉시 파기하게 하고 있습니다.
<br /><br />
                </PrivacyPopupSpanBlock>

                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="15%" />
                        <col width="30%" />
                        <col width="30%" />
                        <col width="25%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>구분 </td>
                            <td>수탁자 </td>
                            <td>위탁업무 </td>
                            <td>보유 및 이용기간 </td>
                        </tr>
                        <tr>
                            <td>주문/배송  </td>
                            <td>CJ택배, 우체국택배, 현대택배, 대한통운, 한진택배 외 기타 택배사  </td>
                            <td>배송 업무  </td>
                            <td rowSpan='4'>회원 탈퇴 시 또는 위탁 계약 종료 시까지  </td>
                        </tr>
                        <tr>
                            <td>결제처리  </td>
                            <td>네이버 파이낸셜 <br />(주)부트페이 <br />이니시스  </td>
                            <td>상품 구매에 필요한 신용카드, 현금결제 등의 결제정보 전송  </td>
                        </tr>
                        <tr>
                            <td>알림발송  </td>
                            <td>주식회사 카카오   </td>
                            <td>알림톡 서비스 제공   </td>
                        </tr>
                        <tr>
                            <td>본인확인   </td>
                            <td>다날    </td>
                            <td>본인인증    </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>


                <PrivacyPopupSpanBlock>
                    <br /><br />
                    7. 회원의 권리
                    <br /><br />
                    회원님은 언제든지 회원님의 개인정보를 조회하거나 수정할 수 있으며 회원 탈퇴 절차를 통하여 개인정보 이용에 대한 동의 등을 철회할 수 있습니다.
                    <br /><br />


7.1 개인정보 조회/수정
<br /><br />

개인정보 조회는 어디가구 사이트의 [ 마이 페이지 ] 내의 [ 회원정보 관리 ] 항목에서 확인 가능하며, 회원 탈퇴(동의 철회)는 [ 마이 페이지 ] 내의 [ 회원정보 관리 ] 항목 하단의 ‘회원 탈퇴’를 통하여 탈퇴하실 수 있습니다. 이 외에도 어디가구 고객센터 및 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하여 열람/수정을 요청하실 수 있습니다.

<br /><br />

7.2 개인정보 오류 정정 시
<br /><br />

개인정보 정정 완료 전까지 개인정보를 이용 • 제공하지 않습니다. 그리고 회원님의 요청에 의해 해지 또는 삭제된 개인정보는 『2. 개인정보의 보유 및 이용기간』에 명시된 바에 따라 취급하고 그 외의 용도로 열람 또는 이용할 수 없도록 조치하고 있습니다.

<br /><br />

※ 만 14세 이상인 경우에만 회원가입이 가능하며 개인정보의 수집/이용에 법정대리인의 동의가 필요한 만 14세 미만 아동의 개인정보는 원칙적으로 수집하지 않습니다.


<br /><br />


8. 회원의 의무
<br /><br />


회원님은 자신의 개인정보를 보호할 의무가 있으며, 회원님 본인의 부주의 등으로 개인정보가 유출되어 발생한 문제에 대해서는 어디가구는 일체의 책임을 지지 않습니다. 회원님의 부정확한 정보입력으로 발생하는 문제의 책임은 회원님 본인에게 있으며, 타인의 개인정보를 도용하여 회원가입 또는 서비스 이용 시 회원자격 상실과 함께 개인정보에 관한 법률에 의거하여 처벌될 수 있습니다. 아이디, 비밀번호를 포함한 회원님의 개인정보가 유출되지 않도록 조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오. 회원님은 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보보호법』 등 기타 개인정보에 관한 법률을 준수하여야 합니다.

<br /><br />

9. 링크 사이트에 대한 책임

<br /><br />

어디가구는 회원님에게 외부 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다. 이 경우 어디가구는 외부 웹사이트 및 자료에 대한 통제권이 없으므로 그로부터 제공받는 서비스나 자료의 유용성에 대해 책임질 수 없으며 보증할 수 없습니다. 어디가구가 포함하고 있는 링크(Click)를 통하여 타 사이트(Site)의 페이지로 옮겨갈 경우 해당 웹사이트의 개인정보처리방침은 어디가구와 무관하므로 새로 방문한 웹사이트의 정책을 검토하시기 바랍니다.


<br /><br />


10. 개인정보 자동수집 장치(쿠키)의 운영 및 거부

<br /><br />

어디가구는 회원님에게 보다 적절하고 유용한 서비스를 제공하기 위하여 회원님의 정보를 수시로 저장하고 불러오는 ‘쿠키(cookie)’를 사용합니다. 이용자는 스스로 쿠키의 설치 및 수집을 거부할 수 있습니다. 다만, 쿠키의 저장을 거부할 경우, 로그인이 필요한 일부 서비스 이용에 제한이 생길 수 있습니다.

<br /><br />

10.1 브라우저 별 쿠키 저장 거부 방법 <br /><br />
                </PrivacyPopupSpanBlock>

                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="30%" />
                        <col width="70%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>브라우저  </td>
                            <td>설정 방법  </td>
                        </tr>
                        <tr>
                            <td>Internet Explorer    </td>
                            <td>[도구] 메뉴에서 [인터넷 옵션]을 선택 → [개인정보]를 클릭 → [고급]을 클릭 → 쿠키 허용여부를 선택   </td>
                        </tr>
                        <tr>
                            <td>Chrome    </td>
                            <td>[설정] → 화면 하단의 [고급 설정 표시] 선택 → 개인정보 섹션의 [콘텐츠 설정] 버튼 클릭 → 쿠키 섹션에서 직접 설정  </td>
                        </tr>
                        <tr>
                            <td>Safari     </td>
                            <td>MacOS 상단 좌측 메뉴바에서 [Safari]에서 [환경설정]을 선택 → [환경설정] 창에서 [보안]으로 이동하여 쿠키 허용여부 선택  </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>

                <br /><br />
                <PrivacyPopupSpanBlock>
                    11. 개인정보의 기술적/관리적 보호 대책
                <br /><br />


11.1 기술적 조치 <br /><br />

- 개인정보의 암호화 : 법에서 요구하는 중요 개인정보는 암호화 되어 저장 및 관리되고 있어 본인만이 알 수 있으며, 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
<br /><br />
- 개인정보처리시스템 등에 대한 접근권한 관리 : 개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
<br /><br />
- 접속기록의 보관 및 위 변조 방지 : 개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며 접속 기록이 위 • 변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.
<br /><br />


11.2 관리적 조치 <br /><br />

- 내부관리계획의 수립 및 시행 : 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
<br /><br />
- 정기적인 자체 감사 실시 : 개인정보 취급 관련 안전성 확보를 위해 정기적(분기1회)으로 자체 감사를 실시하고 있습니다.
<br /><br />


11.3  물리적 조치 <br /><br />

- 문서보안을 위한 잠금 장치의 사용 : 개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.
<br /><br />
- 비인가자에 대한 출입 통제 : 개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립 • 운영하고 있습니다.
<br /><br />



12. 개인정보 보호 책임자
<br /><br />
회원님의 개인정보를 보호하고 개인정보와 관련된 불만 등을 처리하기 위하여 어디가구는 고객서비스담당 부서 및 개인정보보호책임자를 두고 있습니다. 회원님의 개인정보와 관련한 문의사항은 아래의 고객서비스담당 부서 또는 개인정보보호책임자에게 연락하여 주시기 바랍니다.
                </PrivacyPopupSpanBlock>
                <br /><br />
                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="30%" />
                        <col width="70%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>개인정보 보호 책임자   </td>
                            <td>• 성명 : 유수종  <br />
                                • 직책 : 개인정보관리책임자  <br />
                                • 이메일 주소 : syu@mindgroup.co.kr </td>
                        </tr>
                        <tr>
                            <td>문의처    </td>
                            <td>• 부서명 : 고객센터  <br />• 전화 : 02-6713-6420  </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>
                <PrivacyPopupSpanBlock>
                    <br /><br />
                12.1 개인정보 침해에 대한 신고나 상담
                <br /><br />
                </PrivacyPopupSpanBlock>

                <PrivacyPopupTableBlock>
                    <colgroup>
                        <col width="30%" />
                        <col width="70%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>개인정보분쟁조정위원회    </td>
                            <td>1833-6972 </td>
                        </tr>
                        <tr>
                            <td>개인정보침해 신고센터     </td>
                            <td>• 국번없이 118
                                <br />• <a href="privacy.kisa.or.kr">privacy.kisa.or.kr</a>
                                <br />• 118@kisa.or.kr
                            </td>
                        </tr>
                        <tr>
                            <td>대검찰청 사이버범죄수사단</td>
                            <td>
                                • <a href="http://www.spo.go.kr"> www.spo.go.kr</a>
                                <br /> 국번없이 1301
                            </td>
                        </tr>
                        <tr>
                            <td>경찰청 사이버안전국  </td>
                            <td>
                                cyberbureau.police.go.kr
                                <br /> 국번없이 182
                            </td>
                        </tr>
                    </tbody>
                </PrivacyPopupTableBlock>

                <PrivacyPopupSpanBlock>
                    <br /><br />
                    13. 개인정보 처리 방침의 개정과 그 공지
                <br /><br />
                본 개인정보 처리 방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우 변경사항의 시행일 7일 전부터 공지사항을 통하여 고지합니다. 그러나 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자의 권리에 중요한 변경 사유가 발생하는 경우 최소 30일 전에 공지합니다. 또한 관련 법령이나 회사 정책의 변경으로 불가피하게 처리방침을 변경해야하는 경우, 웹사이트 공지사항을 통해 빠르게 알려드리고 있으니 참고해주시기 바랍니다.
                <br /><br />
                • 개인정보 처리방침 버전번호 : Ver.0.1
                <br />
• 현재 개인정보 처리방침 고지 일자 : 2020년 7월 1일
<br />
• 현재 개인정보 처리방침 시행 일자 : 2020년 7월 1일
<br />
                </PrivacyPopupSpanBlock>

            </PrivacyPopupContentsBlock>
        </PrivacPopupBlock >
    );
};

export default PrivacyPopup;
